import React from "react";
import { useMsal } from "@azure/msal-react";

// SignInButton component for signing in using MSAL
// It uses the useMsal hook to access the MSAL instance and calls loginRedirect on button click
// This component can be used to initiate the login process in a React application
export const SignInButton = () => {
  const { instance } = useMsal();
  const handleLogin = () => {
    instance.loginRedirect();
  };
  return <button onClick={handleLogin}>Login</button>;
};

// SignOutButton component for signing out using MSAL
// It uses the useMsal hook to access the MSAL instance and calls logoutRedirect on button click
// This component can be used to initiate the logout process in a React application
export const SignOutButton = () => {
  const { instance } = useMsal();
  const handleLogout = () => {
    instance.logoutRedirect();
  };
  return <button onClick={handleLogout}>Logout</button>;
};
